import { render } from "./openMini.vue?vue&type=template&id=1f912592&scoped=true&ts=true"
import script from "./openMini.vue?vue&type=script&lang=ts"
export * from "./openMini.vue?vue&type=script&lang=ts"

import "./openMini.vue?vue&type=style&index=0&id=1f912592&scoped=true&lang=css"

import exportComponent from "/Users/jacob/Documents/work/fan/fanwood/tui-weixin/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.25_vue@3.5.25_typescript@4.1.6__webpack@4.47.0_webpack-cli@4.10.0_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f912592"]])

export default __exports__